const PublicRoute = ({children}: { children: JSX.Element }): JSX.Element => {
  return children;
}

export default PublicRoute;
